import React from "react"

import { CatalogItem } from "../../types"
import { getImageUrl as getFallbackSvg } from "../utils"
import * as styles from "./index.module.scss"

type Props = Pick<
  CatalogItem,
  "logoImagePath" | "cardImagePath" | "name" | "category"
>

function VendorCardImage({
  logoImagePath,
  cardImagePath,
  name,
  category,
}: Props) {
  const imageUrl = cardImagePath ?? logoImagePath
  const imageElement =
    imageUrl && imageUrl.includes(".svg") ? (
      <object
        type="image/svg+xml"
        data={imageUrl}
        aria-label={`${name} Card`}
      />
    ) : (
      <img src={imageUrl} alt={`${name} Card`} />
    )
  return (
    <div className={styles.imageContainer}>
      {imageUrl ? imageElement : getFallbackSvg(category)}
    </div>
  )
}

export default VendorCardImage
